import React, { useEffect } from "react";
import AOS from "aos";
import page_json from "./config/config.json";
import { Helmet } from "react-helmet";
import HeroComponent from "./HeroComponent";
import config from "../config";

const textDataUrl = `${page_json.page_jsons.ItServices}?v=${config.VERSION}`;
const textDataResponse = await fetch(textDataUrl);
const textData = await textDataResponse.json();

function ItServices() {
  useEffect(() => {
    AOS.init(); // Initialize AOS
  }, []);

  return (
    <div data-aos="fade-up" className="IT-services">
      <Helmet>
        <meta
          name="description"
          content="Building and managing organizational excellence with all-encompassing IT Services"
        />
        <title>IT Services | Services | Engineersmind</title>
      </Helmet>
      {/* <div className="container-fluid m-0 p-0 brd-crmb">
				<div className="container">
					<div className="row">
						<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
							<nav aria-label="breadcrumb">
								<ol className="breadcrumb">
									<li className="breadcrumb-item"><a href="/">Home </a></li>
									<li className="breadcrumb-item"><a href="/Services/Digital-Transformation">Services</a></li>
									<li className="breadcrumb-item active" aria-current="page">Managed IT Services</li>
								</ol>
							</nav>
						</div>
					</div>
				</div>
			</div> */}

      <HeroComponent
        bgImageMobile={textData.layer1.mobilebannerimg}
        bgImage={textData.layer1.img}
        textContent={
          <h1>
            {textData.layer1.heading.text1}
            {textData.layer1.heading.text2}
            <br /> {textData.layer1.heading.text3}
            <span>{textData.layer1.heading.text4}</span>
          </h1>
        }
        breadcrumbs={
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="/">Home </a>
            </li>
            <li className="breadcrumb-item">
              <a href="/Services/Digital-Transformation">Services</a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Managed IT Services
            </li>
          </ol>
        }
      />

      <div className="container-fluid m-0 caseStudyContent">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <h1 className="mb-2">{textData.managedITServices.title}</h1>
              <h3 className="mb-3">{textData.managedITServices.heading}</h3>
              <div className="row introductionsection digitalPortals-left-img-row">
                <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12  d-flex justify-content-center align-items-center">
                  <img
                    className="ModernPortals-left-img"
                    src={textData.managedITServices.img}
                    alt="overview-img"
                  />
                </div>
                <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12  d-flex flex-column justify-content-center">
                  <div className="p-0">
                    {/* <h3>{textData.managedITServices.heading}</h3> */}
                    <p className="text-20">
                      {textData.managedITServices.description1}
                    </p>
                    <p className="text-20 mt-3">
                      {textData.managedITServices.description2}
                    </p>
					<p className="text-20 mt-3">
                      {textData.managedITServices.description3}
                    </p>
                    <p className="text-20 mt-3">
                      {textData.managedITServices.pointsTitle}
                    </p>
                    <div className="pt-2 text-20">
                      <ul className="healthcare-list">
                        {textData.managedITServices.points.map(
                          (point, index) => {
                            return (
                              <li
                                className="healthcare-list-point"
                                key={index}
                                dangerouslySetInnerHTML={{ __html: point }}
                              />
                            );
                          }
                        )}
                      </ul>
                    </div>
                    <p className="text-20 mt-3">
                      {textData.managedITServices.description4}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div className="container-fluid ModernPortals second">
        <div className="container">
          <h1 className="mb-2">{textData.microsoftManagedITServices.title}</h1>
          <h3 className="mb-3">
            {
              textData.microsoftManagedITServices
                .comprehensiveSupportForMicrosoftEcosystems.title
            }
          </h3>
          <div className="p-0 text-20">
            <p>
              {
                textData.microsoftManagedITServices
                  .comprehensiveSupportForMicrosoftEcosystems.description1
              }
            </p>
            <p>
              {
                textData.microsoftManagedITServices
                  .comprehensiveSupportForMicrosoftEcosystems.description2
              }
            </p>
          </div>
          <div className="row full-stack ">
            <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12  d-flex  align-items-center">
              <div className="portal mt-3">
                <p className="portal-desc text-20 mb-2">
                  {
                    textData.microsoftManagedITServices
                      .comprehensiveSupportForMicrosoftEcosystems
                      .keyFeaturesTitle
                  }
                </p>
                {textData.microsoftManagedITServices.comprehensiveSupportForMicrosoftEcosystems.keyFeatures.map(
                  (feature, index) => {
                    return (
                      <div className="d-flex w-100 list-item mb-2" key={index}>
                        <img
                          src={textData.bulletPoints.img}
                          alt="bullet-point"
                        />
                        <div className="w-100">
                          <p className="fst-italic text-20">
                            <strong>{feature.title}</strong>
                          </p>
                          {feature.points ? (
                            <ul className="healthcare-list">
                              {feature.points.map((point, index) => {
                                return (
                                  <li
                                    className="healthcare-list-point"
                                    key={index}
                                    dangerouslySetInnerHTML={{
                                      __html: point,
                                    }}
                                  />
                                );
                              })}
                            </ul>
                          ) : (
                            <p className="portal-desc text-20">
                              {feature.description}
                            </p>
                          )}
                          {feature?.keyFeatures && (
                            <ul className="healthcare-list">
                              {feature?.keyFeatures.map((point, index) => {
                                return (
                                  <li
                                    className="healthcare-list-point"
                                    key={index}
                                  >
                                    <strong>{point.title}</strong> -{" "}
                                    {point.description}
                                  </li>
                                );
                              })}
                            </ul>
                          )}
                        </div>
                      </div>
                    );
                  }
                )}
              </div>
            </div>
            <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12  d-flex justify-content-center align-items-center">
              <img
                src={
                  textData.microsoftManagedITServices
                    .comprehensiveSupportForMicrosoftEcosystems.img
                }
                className="img-fluid ModernPortals-left-img"
                alt="Resilient_solutions"
              />
            </div>
          </div>
          <div className="pt-2 text-20">
            <p>
              {
                textData.microsoftManagedITServices
                  .comprehensiveSupportForMicrosoftEcosystems.description3
              }
            </p>
          </div>
        </div>
      </div>

      <div className="container-fluid ModernPortals">
        <div className="container">
          <h1 className="mb-2">
            {textData.salesforceCRMManagedServices.title}
          </h1>
          <h3 className="mb-3">
            {
              textData.salesforceCRMManagedServices
                .maximizeYourSalesforceInvestment.title
            }
          </h3>
          <div className="p-0 text-20">
            <p
              dangerouslySetInnerHTML={{
                __html:
                  textData.salesforceCRMManagedServices
                    .maximizeYourSalesforceInvestment.description1,
              }}
            />
            <p>
              {
                textData.salesforceCRMManagedServices
                  .maximizeYourSalesforceInvestment.description2
              }
            </p>
          </div>
          <div className="row ">
          <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12  d-flex justify-content-center align-items-center">
              <img
                src={
                  textData.salesforceCRMManagedServices
                    .maximizeYourSalesforceInvestment.img
                }
                className="img-fluid ModernPortals-left-img"
                alt="Resilient_solutions"
              />
            </div>
            <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12  d-flex  align-items-center">
              <div className="portal">
                <p className="portal-desc text-20 mt-3">
                  {
                    textData.salesforceCRMManagedServices
                      .maximizeYourSalesforceInvestment.keyFeaturesTitle
                  }
                </p>
                {textData.salesforceCRMManagedServices.maximizeYourSalesforceInvestment.keyFeatures.map(
                  (feature, index) => {
                    return (
                      <div className="d-flex w-100 list-item" key={index}>
                        <img
                          src={textData.bulletPoints.img}
                          alt="bullet-point"
                        />
                        <div className="w-100">
                          <p className="fst-italic text-20">
                            <strong>{feature.title}</strong>
                          </p>
                          {feature.points ? (
                            <ul className="healthcare-list">
                              {feature.points.map((point, index) => {
                                return (
                                  <li
                                    className="healthcare-list-point"
                                    key={index}
                                    dangerouslySetInnerHTML={{
                                      __html: point,
                                    }}
                                  />
                                );
                              })}
                            </ul>
                          ) : (
                            <p className="portal-desc text-20">
                              {feature.description}
                            </p>
                          )}
                        </div>
                      </div>
                    );
                  }
                )}
              </div>
            </div>
          </div>
          <div className="pt-4 text-20">
            <p
              dangerouslySetInnerHTML={{
                __html:
                  textData.salesforceCRMManagedServices
                    .maximizeYourSalesforceInvestment.description3,
              }}
            />
          </div>
        </div>
      </div>

      <div className="container-fluid ModernPortals second">
        <div className="container">
          <h1 className="mb-2">
            {textData.strategicManagedServicesPartner.title}
          </h1>
          <div className="p-0 text-20">
            <p>{textData.strategicManagedServicesPartner.description1}</p>
          </div>
          <div className="row full-stack">
            <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12  d-flex  align-items-center">
              <div className="portal mt-3">
                <p className="portal-desc text-20 mb-2">
                  {textData.strategicManagedServicesPartner.description2}
                </p>
                <p className="portal-desc text-20 mb-2">
                  {textData.strategicManagedServicesPartner.pointsTitle}
                </p>
                <div className="d-flex w-100">
                  <div className="w-100">
                    <ul className="healthcare-list">
                      {textData.strategicManagedServicesPartner.points.map(
                        (point, index) => {
                          return (
                            <li className="healthcare-list-point" key={index}>
                              {point}
                            </li>
                          );
                        }
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12  d-flex justify-content-center align-items-center">
              <img
                src={textData.strategicManagedServicesPartner.img}
                className="img-fluid ModernPortals-left-img midp1"
                alt="Resilient_solutions"
              />
            </div>
          </div>
          <div className="pt-2 text-20">
            <p>{textData.strategicManagedServicesPartner.description3}</p>
          </div>
        </div>
      </div>

	  <div className="container-fluid whyChoose ModernPortals">
        <div className="container">
          <h1>
            <span>{textData.whyEngineersmind.title}</span>
          </h1>
          <p className="text-20 mb-4" dangerouslySetInnerHTML={{ __html: textData.whyEngineersmind.description1 }} />
          <div className="pt-0 text-20">
          <p className="text-20 mb-3" dangerouslySetInnerHTML={{ __html: textData.whyEngineersmind.pointsTitle }} />
            <ul className="whychoose-points">
              {textData.whyEngineersmind.points.map((point, index) => {
                return (
                  <li className="" key={index}>
                    <p dangerouslySetInnerHTML={{ __html: point }}></p>
                  </li>
                );
              })}
            </ul>
          </div>
          <p className="pt-2 text-20" dangerouslySetInnerHTML={{ __html: textData.whyEngineersmind.description2 }} />
          <p className="pt-2 text-20" dangerouslySetInnerHTML={{ __html: textData.whyEngineersmind.description3 }} />
        </div>
      </div>
    </div>
  );
}

export default ItServices;
